let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3nPyl")).then(() => parcelRequire('1XhGw'));